// Admin data layer — full read/write access to Firestore (admins bypass the
// published-only rules) + Cloud Storage uploads. Used only inside /admin.
import { db, storage } from "@/lib/firebase";
import {
  collection,
  doc,
  getDocs,
  getDoc,
  addDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

const map = (d) => ({ id: d.id, ...d.data() });

/* ---- generic collection CRUD (drafts included) ---- */
export async function listAll(coll) {
  const snap = await getDocs(collection(db, coll));
  return snap.docs.map(map).sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}
export async function getOne(coll, id) {
  const s = await getDoc(doc(db, coll, id));
  return s.exists() ? map(s) : null;
}
export async function createItem(coll, data, id) {
  const payload = { ...data, createdAt: serverTimestamp(), updatedAt: serverTimestamp() };
  if (id) {
    await setDoc(doc(db, coll, id), payload);
    return id;
  }
  const r = await addDoc(collection(db, coll), payload);
  return r.id;
}
export async function updateItem(coll, id, data) {
  await updateDoc(doc(db, coll, id), { ...data, updatedAt: serverTimestamp() });
}
export async function removeItem(coll, id) {
  await deleteDoc(doc(db, coll, id));
}

/* ---- singletons (seo/global, codeInjection/global, settings/site) ---- */
export async function getSingleton(coll, id) {
  return getOne(coll, id);
}
export async function saveSingleton(coll, id, data) {
  await setDoc(doc(db, coll, id), { ...data, updatedAt: serverTimestamp() }, { merge: true });
}

/* ---- storage uploads ---- */
export async function uploadImage(file, folder = "media") {
  const safe = file.name.replace(/[^\w.\-]/g, "_");
  const path = `${folder}/${Date.now()}-${safe}`;
  const r = ref(storage, path);
  await uploadBytes(r, file, { contentType: file.type });
  return getDownloadURL(r);
}

/* ---- leads ---- */
export async function listLeads() {
  const snap = await getDocs(collection(db, "leads"));
  return snap.docs.map(map).sort((a, b) => {
    const am = a.createdAt?.toMillis?.() ?? 0;
    const bm = b.createdAt?.toMillis?.() ?? 0;
    return bm - am; // newest first
  });
}
export async function updateLeadStatus(id, status) {
  await updateDoc(doc(db, "leads", id), { status, updatedAt: serverTimestamp() });
}
export async function removeLead(id) {
  await deleteDoc(doc(db, "leads", id));
}

export const LEAD_STATUSES = ["new", "contacted", "followup", "closed"];
